module.exports = __webpack_public_path__ + "static/media/infracciones_mop.b1bb778e.svg";